/* Calls to this app's own Worker (Gmail, the paint data folder), signed with a Shopify session token. */

async function call(path, init = {}) {
  const token = await shopify.idToken();
  const res = await fetch(path, {
    ...init,
    headers: { ...(init.headers || {}), authorization: `Bearer ${token}`, ...(init.body ? { 'content-type': 'application/json' } : {}) },
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(body.error || `The server answered ${res.status}`);
    err.status = res.status;
    throw err;
  }
  return body;
}

export const getConfig = () => call('/api/config');
export const sendMail = (msg) => call('/api/mail/send', { method: 'POST', body: JSON.stringify(msg) });
export const getConversation = (email) => call(`/api/mail/conversation?email=${encodeURIComponent(email)}`);
export const getMessage = (id) => call(`/api/mail/message?id=${encodeURIComponent(id)}`);

export function toast(message, isError = false) {
  try { shopify.toast.show(message, { isError, duration: isError ? 6000 : 3000 }); } catch { /* outside admin */ }
}

export function busy(on) {
  try { shopify.loading(!!on); } catch { /* outside admin */ }
}

/* "a@x.com" from "Jane <a@x.com>". */
export function bareEmail(s) {
  const m = /<([^>]+)>/.exec(s || '');
  return (m ? m[1] : s || '').trim().toLowerCase();
}

export const displayName = (s) => {
  const m = /^\s*"?([^"<]+?)"?\s*</.exec(s || '');
  return m ? m[1] : bareEmail(s);
};
